import { render, staticRenderFns } from "./MarketPlaceSelectComponent.vue?vue&type=template&id=18faf4c1&scoped=true&"
import script from "./MarketPlaceSelectComponent.vue?vue&type=script&lang=js&"
export * from "./MarketPlaceSelectComponent.vue?vue&type=script&lang=js&"
import style0 from "./MarketPlaceSelectComponent.vue?vue&type=style&index=0&id=18faf4c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18faf4c1",
  null
  
)

export default component.exports